// Báo cáo — tự chọn giao diện theo loại đơn vị và chế độ (Quản lý / Bán hàng):
//  · Đại lý, chế độ Quản lý: Mạng lưới · Theo tháng (GĐ10)
//  · CTV, chế độ Quản lý:    Theo tháng (hoa hồng, GĐ10)
//  · Shop, và Đại lý / CTV ở chế độ Bán hàng: báo cáo bán hàng (đơn tự bán)

import { getAuthState } from '@/lib/auth'
import { onlyWorkMode, useWorkMode } from '@/lib/workMode'
import { PageHeader } from '@/components/ui/page-header'
import { AgencyReportView } from '@/components/reports/AgencyReportView'
import { ShopReportView } from '@/components/reports/ShopReportView'
import { CtvMonthlyReport } from '@/components/reports/MonthlyReport'

export default function ReportsPage() {
  const auth = getAuthState()
  const shop = auth.shops.find((s) => s.shopId === auth.activeShopId)
  const role = shop?.role
  const tenantType = shop?.tenantType || (role === 'agency' || role === 'ctv' ? role : 'shop')
  // Cấp trên chỉ bật một giao diện → báo cáo của giao diện đó (docs/KE_HOACH_CHON_GIAO_DIEN_CAP_DUOI.md)
  const storedMode = useWorkMode()
  const mode = onlyWorkMode(shop?.workModes) ?? storedMode

  if ((tenantType === 'agency' || tenantType === 'ctv') && mode === 'sell') return <ShopReportView />
  if (tenantType === 'agency' || role === 'agency') return <AgencyReportView />
  if (tenantType === 'ctv' || role === 'ctv') return <CtvReportView />
  return <ShopReportView />
}

function CtvReportView() {
  // Đơn tự bán xem ở chế độ Bán hàng → Báo cáo
  return (
    <div className="mx-auto max-w-7xl space-y-5">
      <PageHeader title="Báo cáo" />
      <CtvMonthlyReport />
    </div>
  )
}
